import { saveBlobToIndexedDB, getBlobFromIndexedDB, deleteKeysFromIndexedDB } from '@/utils/indexedDB';

const DB_NAME = 'LogFormat';
const STORE_NAME = 'PDFs';
const VERSION = 1;

const LogFormatPdfStore = {
    save: (pdfId, blob, metadata = {}) => {
        const data = {
            blob,
            metadata,
        };

        return saveBlobToIndexedDB({
            dbName: DB_NAME,
            storeName: STORE_NAME,
            version: VERSION,
            key: pdfId,
            blob: data,
        });
    },

    get: async (pdfId) => {
        const data = await getBlobFromIndexedDB({
            dbName: DB_NAME,
            storeName: STORE_NAME,
            version: VERSION,
            key: pdfId,
        });

        if (data) {
            return {
                blob: data.blob,
                metadata: data.metadata,
            };
        }
        return null;
    },
    delete: async (key) => {
        if (key) {
            await deleteKeysFromIndexedDB({
                dbName: DB_NAME,
                storeName: STORE_NAME,
                version: VERSION,
                keys: [key],
            });
        }
        return null;
    },
};

export default LogFormatPdfStore;
